<script setup lang="ts">
const ready = useAuthReady()

const { initTheme } = useAppTheme()
initTheme()
</script>

<template>
  <NuxtRouteAnnouncer />
  <NuxtLoadingIndicator color="#0eaac8" :height="2" />
  <template v-if="ready">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <AppToast />
  </template>
</template>
